export const PROGRAM_TITLE_COMCAST: string = "Comcast Corporation - NBC Universal";
